import { Skeleton } from '@mui/material';

import TableBodyCell from 'components/common/Table/TableBodyCell/TableBodyCell';
import TableRow from 'components/common/Table/TableRow/TableRow';
import { USERS_TABLE_COLUMNS_AMOUNT } from 'components/users/users.constants';

import styles from './UsersTableSkeletonRow.module.scss';

const UsersTableSkeletonRow = () => {
  return (
    <TableRow className={styles.tableRowContainer} isHoverDisabled>
      {Array.from(Array(USERS_TABLE_COLUMNS_AMOUNT).keys()).map((skeletonColumn: number) => (
        <TableBodyCell key={skeletonColumn}>
          <Skeleton variant="rounded" height={16} animation="wave" />
        </TableBodyCell>
      ))}
    </TableRow>
  );
};

export default UsersTableSkeletonRow;
